export default function () {
  document.addEventListener('DOMContentLoaded', () => {
    const table = document.getElementById('project-groups-table')
    if (!table) return

    const tbody = table.querySelector('tbody')
    if (!tbody) return

    let dragSrcEl: HTMLTableRowElement | null = null

    function handleDragStart(this: HTMLTableRowElement, e: DragEvent) {
      dragSrcEl = this
      this.style.opacity = '0.4'

      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setData('text/html', this.outerHTML)
      }
    }

    function handleDragOver(this: HTMLTableRowElement, e: DragEvent) {
      if (e.preventDefault) {
        e.preventDefault()
      }
      if (e.dataTransfer) {
        e.dataTransfer.dropEffect = 'move'
      }
      return false
    }

    function handleDragEnter(this: HTMLTableRowElement, e: DragEvent) {
      this.classList.add('drag-over')
    }

    function handleDragLeave(this: HTMLTableRowElement, e: DragEvent) {
      this.classList.remove('drag-over')
    }

    function handleDrop(this: HTMLTableRowElement, e: DragEvent) {
      if (e.stopPropagation) {
        e.stopPropagation()
      }

      if (dragSrcEl !== this) {
        // Move the dragged element to the new position
        const draggedIndex = Array.from(tbody.children).indexOf(dragSrcEl!)
        const targetIndex = Array.from(tbody.children).indexOf(this)

        if (draggedIndex < targetIndex) {
          tbody.insertBefore(dragSrcEl!, this.nextSibling)
        } else {
          tbody.insertBefore(dragSrcEl!, this)
        }

        // Send update to server
        updateProjectGroupsOrder()
      }

      return false
    }

    function handleDragEnd(this: HTMLTableRowElement, e: DragEvent) {
      this.style.opacity = ''

      // Clean up
      const rows = tbody.querySelectorAll('tr')
      rows.forEach((row) => {
        row.classList.remove('drag-over')
      })
    }

    function updateProjectGroupsOrder() {
      const projectGroupIds: number[] = []
      const rows = tbody.querySelectorAll('tr')

      rows.forEach((row) => {
        // Look for the link in any td, not just first-child since we added drag handle
        const link = row.querySelector('td a[href*="/project-groups/"]') as HTMLAnchorElement
        if (link) {
          const href = link.getAttribute('href')
          if (href) {
            const matches = href.match(/\/project-groups\/(\d+)\/project-tickets/)
            if (matches && matches[1]) {
              projectGroupIds.push(parseInt(matches[1], 10))
            }
          }
        }
      })

      if (projectGroupIds.length > 0) {
        // Get CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

        fetch('/project-groups/reorder', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken || '',
          },
          body: JSON.stringify({
            project_group_ids: projectGroupIds,
          }),
        }).catch((error) => {
          console.error('Error reordering project groups:', error)
          alert('Error reordering project groups. Please reload and try again.')
        })
      }
    }

    // Only enable drag-and-drop if user has drag handles (update permission)
    const hasDragHandles = tbody.querySelector('.drag-handle') !== null
    if (!hasDragHandles) return

    // Make table rows draggable, but only when initiated from drag handle
    const rows = tbody.querySelectorAll('tr')
    rows.forEach((row) => {
      const htmlRow = row as HTMLTableRowElement
      const dragHandle = htmlRow.querySelector('.drag-handle')

      if (dragHandle) {
        // Set draggable to false by default
        htmlRow.draggable = false

        // Enable dragging only when mousedown starts on the drag handle
        dragHandle.addEventListener('mousedown', (e) => {
          htmlRow.draggable = true
        })

        // Disable dragging when mouse leaves the drag handle
        dragHandle.addEventListener('mouseleave', (e) => {
          htmlRow.draggable = false
        })

        // Prevent dragging when clicking anywhere else on the row
        htmlRow.addEventListener('mousedown', (e) => {
          if (!dragHandle.contains(e.target as Node)) {
            htmlRow.draggable = false
          }
        })
      }

      htmlRow.addEventListener('dragstart', handleDragStart)
      htmlRow.addEventListener('dragenter', handleDragEnter)
      htmlRow.addEventListener('dragover', handleDragOver)
      htmlRow.addEventListener('dragleave', handleDragLeave)
      htmlRow.addEventListener('drop', handleDrop)
      htmlRow.addEventListener('dragend', handleDragEnd)
    })
  })
}
